import React from 'react';

import './backdrop.scss';

const Backdrop = (props) => (
    <div className='Backdrop' onClick={ () => props.action() }></div>
)

export default Backdrop